module.exports = __webpack_public_path__ + "img/shexaingtou.ddac2bd7.png";